import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import { useParams } from 'react-router-dom';
import { useToast } from '../../controls/Toast/ToastService';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { GetPatientInTheCabin, GetPatientWhoNext, } from '../../../configurations/crud/opdRegisteredCrud';
import { FaCircleInfo } from 'react-icons/fa6';
import { MdErrorOutline } from 'react-icons/md';
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo';
import { LIVE_URL } from '../../../configurations/initUrls';
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { isDisabled } from '@testing-library/user-event/dist/utils';
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import LoadingContainer from '../../controls/LoadingContainer';
import StatusContainer from '../../controls/StatusContainer';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import moment from 'moment';

export default function Display() {
  const { start, end } = useGlobalLoader()
  const [opdCenters, setOpdCenter] = useState([]);
  const [loding, setLoding] = useState(false);
  const toast = useToast();
  const { centerid } = useParams()
  const [doctorStatus, setDoctorStatus] = useState(1);
  const loginInfo = getLoginInfo()
  const [centerData, setCenterData] = useState();
  const [currentData, setCurrentData] = useState();
  const [nextPatientData, setNextPatientData] = useState();
  const [today, setToday] = useState(new Date());


  const audioRef = useRef(null);
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])
  const ringBell = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
    }
  };

  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "3": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "4": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "5": {
            ringBell(); break;
          }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block

  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Display", loginInfo.userName + "_" + centerid)
    GetCenterDetails()
    GetPatientInTheCabin()
    GetPatientWhoNext()

    let myInterval = setInterval(() => {
      setToday(new Date())
    }, 1000);

  }, []);

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
        // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      // toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }
  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        // toast.open(errors, <MdErrorOutline />, "danger")
        setLoding(false)
        end()
      })
    }
    catch (error) {
      alert(error)
    }
  }
  const GetCenterDetails = () => {
    setLoding(true);
    start()
    opdCentersCrud.GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        // toast.open(errors, <MdErrorOutline />, "danger");
        setLoding(false);
        end()
      });
  }
  return (
    <Container>
      <div className="flex flex-col items-center">
        <audio
          ref={audioRef}
          src="/assets/audio/mixkit-cartoon-door-melodic-bell-110.wav"
          preload="auto"
        />
      </div>

      <div class="flex flex-col w-full md:mx-2 ">

        <div class="w-full">
          <Card isBorder={true} isBack={true} title={<div className='w-full flex items-center justify-between'><span>{centerData && ("Today: " + moment(new Date()).format("DD/MM/YYYY") + " | Clock: " + moment(today).format("LTS"))}</span></div>} bgColor="bg-[#E6F0FF]" borderColor="border-[#4682B4]" >
            <div class=" flex justify-end rounded-md md:-mt-10 mt-0" role="group">
              <span class={(doctorStatus == 1 ? "bg-green-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 rounded-l-lg "}>
                In The Cabin
              </span>
              <span class={(doctorStatus == 4 ? "bg-orange-500" : "bg-gray-400") + " px-4 py-2 text-sm font-medium text-white  border-gray-200 "}>
                On Rest
              </span>
              <span class={(doctorStatus == 0 ? "bg-red-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 rounded-r-lg"}>
                Offline
              </span>
            </div>
            <div class="text-gray-700 mt-4">
              <div class="text-center">
                <div class="justify-center flex flex-col items-center">
                  {centerData &&
                    <>
                      <div class="px-4 font-semibold text-5xl">{centerData.centerName}</div>
                      <span className='text-xl font-normal'>{"Opd Time: " + moment(centerData.opdStartTime).format("LT") + "-" + moment(centerData.opdEndTime).format("LT")}</span>
                      <div class="text-3xl">{centerData.address}</div>
                    </>
                  }
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div class="my-4"></div>
        <div class="grid grid-cols-2 gap-4" >
          <div class="col-span-4 md:col-span-1" >
            <Card isBorder={true} borderColor="border-[#FF8C00]">
              {loding ?
                <LoadingContainer text="Please wait..." />
                :
                <div class="text-[#7A4C00]">
                  <div class="text-center text-2xl">
                    {currentData ?
                      <>
                        <div class="px-2 py-2 font-semibold">Patient In The Cabin</div>
                        <div class="px-2 py-2 text-5xl">{currentData.patientName}</div>
                        <div>
                          <span className='flex items-center justify-center gap-2'>
                            Number:
                            <span>
                              <span className=" text-4xl font-bold" >{currentData.confirmedAllotedNumber}</span>{currentData.confirmedAllotedNumber != currentData.opdNumberAlloted && <span className='text-sm font-normal'>/{currentData.opdNumberAlloted}</span>}
                            </span>
                            <span>
                              <StatusContainer bg={ETypeBg(currentData.type)} text={GetETypeName(currentData.type)} />
                            </span>
                          </span>
                        </div>
                        <div class="px-2 py-2">Ref No. {currentData.id} {currentData.registeredIdForRef && "/" + currentData.registeredIdForRef}</div>
                        <div class="my-2 mx-5"></div>
                      </>
                      :
                      <>
                        <div class="px-2 py-2 font-semibold"> Please Start OPD</div>
                      </>
                    }
                  </div>
                </div>
              }
            </Card>
          </div>

          {nextPatientData &&
            <>
              <div class="col-span-4 md:col-span-1" >
                <Card isBorder={true} bgColor="bg-sky-500" borderColor="border-green-500">
                  {loding ?
                    <LoadingContainer text="Please wait..." />
                    :
                    <div class="text-[#fefefe]">
                      <div class="text-center text-2xl">
                        <div class="px-4 py-2 font-bold">Next Patient</div>
                        <div class="px-2 py-2 text-5xl">{nextPatientData.patientName}</div>
                        <div>
                          <span className='flex items-center justify-center gap-2'>
                            Number:
                            <span>
                              <span className=" text-4xl font-bold" >{nextPatientData.confirmedAllotedNumber}</span>{nextPatientData.confirmedAllotedNumber != nextPatientData.opdNumberAlloted && <span className='text-sm font-normal'>/{nextPatientData.opdNumberAlloted}</span>}
                            </span>
                            <span>
                              <StatusContainer bg={ETypeBg(nextPatientData.type)} text={GetETypeName(nextPatientData.type)} />
                            </span>
                          </span>
                        </div>
                        <div class="px-2 py-2">Ref No. {nextPatientData.id}{nextPatientData.registeredIdForRef && "/" + nextPatientData.registeredIdForRef}</div>
                        <div class="my-2 mx-5"></div>
                      </div>
                    </div>
                  }
                </Card>
              </div>
            </>
          }
        </div>
      </div>

    </Container >

  )
}
